import { cx } from "@/utils";
import Typography from "@components/Typography";

import styles from "./Breakpoint.module.css";

export interface BreakpointProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  title?: string;
}

const Breakpoint = ({ className, title }: BreakpointProps) => (
  <div className={cx(styles.root, className)}>
    {title && (
      <Typography className={styles.title} data-testid="breakpoint-title">
        {title}
      </Typography>
    )}
    <span className={styles.fill} />
  </div>
);

export default Breakpoint;
